export default __webpack_public_path__ + "static/myobrace-2-fa9e543d2bcfcfd168651db3118a91c2.jpg";